import { createDefaultTyrann } from '@apis/common';
import { trackingData, trackingDataBody, trackingDataDeleteQuery } from '@models/TrackingData';
import { formDataEncoder } from '@utils/types';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const trackingDataQuery = t.type({
  page: t.number,
  track_no: h.omittable(t.string),
  transport_status: h.omittable(t.string),
  export_moved_in_status: h.omittable(t.boolean),
});

export type TrackingDataQuery = t.TypeOf<typeof trackingDataQuery>;

export type TrackingDataBody = t.TypeOf<typeof trackingDataBody>;

export const trackingDataApis = createDefaultTyrann({
  '/dashboard/tracking-data/': {
    get: {
      query: trackingDataQuery,
      response: {
        200: t.type({
          count: t.number,
          results: t.array(trackingData),
        }),
      },
    },
  },
  '/dashboard/tracking-data/{track_no}/': {
    get: {
      path: t.type({
        track_no: t.string,
      }),
      response: {
        200: trackingData,
        404: t.type({
          detail: t.string,
        }),
      },
    },
    patch: {
      path: t.type({
        track_no: t.string,
      }),
      body: trackingDataBody,
      response: {
        200: trackingData,
      },
      options: {
        bodyEncoder: formDataEncoder,
      },
    },
    delete: {
      path: t.type({
        track_no: t.string,
      }),
      query: trackingDataDeleteQuery,
      response: {
        204: t.any,
      },
    },
  },
});
